// Image Registry Service
// Centralized registry for all game images (backgrounds and characters)

// ----- Background Images -----
import digipalzHeadquarter from '@/assets/game/bg_imgs/digipalz_headquarter.webp'
import missionBg from '@/assets/game/bg_imgs/mission_one_bg.webp'
import dialogueBg from '@/assets/game/bg_imgs/dialogue_bg.webp'
import backgroundImgCompouterLab from '@/assets/game/bg_imgs/computerLab.webp'
import backgroundImgRedVally from '@/assets/game/bg_imgs/elementry_school_bg.webp'
import backgroundImgPrincipalOffice from '@/assets/game/bg_imgs/principal_office.webp'
import backgroundImgPlayground from '@/assets/game/bg_imgs/playground.webp'
import backgroundImgAzabukiOffice from '@/assets/game/bg_imgs/mrazabuki-office.webp'
import librarySceneBg from '@/assets/game/missions/mission_one/action_imgs/cyber_definition/librarySceneBg.webp'
import policeStationBg from '@/assets/game/bg_imgs/police_station.webp'
import blueMountainBg from '@/assets/game/bg_imgs/blue_cabin.webp'
import kitchenBg from '@/assets/game/bg_imgs/kitchen.webp'
import babyRoomBg from '@/assets/game/bg_imgs/baby_room.webp'
import babyMonitorBg from '@/assets/game/bg_imgs/baby_monitor.webp'
import declanBedroomBg from '@/assets/game/bg_imgs/declan_bedroom.webp'
import cabinFamilyRoomBg from '@/assets/game/bg_imgs/cabin_family_room.webp'
import cabinLivingRoomBg from '@/assets/game/bg_imgs/cabin_living_room.webp'
import caymanAirportBg from '@/assets/game/bg_imgs/cayman_airport.webp'
import caymanSecurityGateBg from '@/assets/game/bg_imgs/cayman_security_gate.webp'
import kitchen2Bg from '@/assets/game/bg_imgs/kitchen.jpg'
import libraryBg from '@/assets/game/bg_imgs/library_bg.webp'

// ----- Character Images -----
import mrPasternakImg from '@/assets/game/character_imgs/mr_pasternack.webp'
import miloImg from '@/assets/game/character_imgs/milo.webp'
import lunaImg from '@/assets/game/character_imgs/luna.webp'
import mrSpivakImg from '@/assets/game/character_imgs/mr_spivak.webp'
import robotoroImg from '@/assets/game/character_imgs/robotoro.webp'
import robotoroDialogueboxImg from '@/assets/game/character_imgs/robotoroDialogueboxImg.webp'
import katieImg from '@/assets/game/character_imgs/katie.webp'
import mrAzabukiImg from '@/assets/game/character_imgs/mr_azabuki.webp'
import principalFinleyImg from '@/assets/game/character_imgs/finley.webp'
import agentPhoebeImg from '@/assets/game/character_imgs/agent_phoebe.webp'
import officerEmilioImg from '@/assets/game/character_imgs/emilio.webp'
import declanImg from '@/assets/game/character_imgs/declan.webp'
import mrsDelavoyImg from '@/assets/game/character_imgs/mrs_delavoy.png'
import astraImg from '@/assets/game/character_imgs/astra.webp'
import speakerImg from '@/assets/game/character_imgs/speaker.png'
import officerEbanksImg from '@/assets/game/character_imgs/officer_ebanks.webp'
import roboGif from '@/assets/game/character_imgs/robotoro.gif'
import msLopez from '@/assets/game/character_imgs/ms_lopez.webp'
import graceImg from '@/assets/game/character_imgs/grace.webp'
// ----- Article Images -----
import newsIconImg from '@/assets/game/icon_imgs/news_icon.svg'
import automImg from '@/assets/game/missions/mission_one/article_imgs/autom_img.webp'
import policeBadgeImg from '@/assets/game/missions/mission_2/article_imgs/police_badge.webp'
import babyImg from '@/assets/game/article_imgs/baby_article.webp'
import mission4ArticleImg from '@/assets/game/missions/mission_4/article_imgs/mission4.webp'
// ----- Action Images -----
import schoolImg from '@/assets/game/action_imgs/school.png'
import pap2Img from '@/assets/game/action_imgs/pap2.png'
import pap3Img from '@/assets/game/action_imgs/pap3.png'
import page9Img from '@/assets/game/action_imgs/page9.png'
import pap1Img from '@/assets/game/action_imgs/pap1.png'
import page8Img from '@/assets/game/action_imgs/page8.png'
import page7Img from '@/assets/game/action_imgs/page7.png'
import page6Img from '@/assets/game/action_imgs/page6.png'
import page5Img from '@/assets/game/action_imgs/page5.png'
import page4Img from '@/assets/game/action_imgs/page4.png'
import page3Img from '@/assets/game/action_imgs/page3.png'
import page2Img from '@/assets/game/action_imgs/page2.png'
import page10Img from '@/assets/game/action_imgs/page10.png'
import page1Img from '@/assets/game/action_imgs/page1.webp'
import glassHouseImg from '@/assets/game/action_imgs/glass_house.webp'
import f1Img from '@/assets/game/action_imgs/f1.png'
import fullNameImg from '@/assets/game/action_imgs/fullName.png'
import declanLetterOpenImg from '@/assets/game/action_imgs/declan_letter_open.png'
import declanLetterCloseImg from '@/assets/game/action_imgs/declan_letter_close.webp'
import astraBagImg from '@/assets/game/action_imgs/astra-bag.png'
import astraBagItem3Img from '@/assets/game/action_imgs/astra-bag-item3.png'
import astraBagItem2Img from '@/assets/game/action_imgs/astra-bag-item2.png'
import addressImg from '@/assets/game/action_imgs/address.png'
import astraBagItem1Img from '@/assets/game/action_imgs/astra-bag-item1.png'
import thumbScanImg from '@/assets/game/action_imgs/thumb_scan.png'
import sockImg from '@/assets/game/action_imgs/sock.webp'
import redFlag3Img from '@/assets/game/action_imgs/red_flag3.png'
import redFlag2Img from '@/assets/game/action_imgs/red_flag2.png'
import redFlag1Img from '@/assets/game/action_imgs/red_flag1.png'
import portalImg from '@/assets/game/action_imgs/portal.webp'
import passwordRule4Img from '@/assets/game/action_imgs/password_rule4.png'
import passwordRule2Img from '@/assets/game/action_imgs/password_rule2.png'
import passwordRule3Img from '@/assets/game/action_imgs/password_rule3.png'
import passwordRule1Img from '@/assets/game/action_imgs/password_rule1.png'
import giftImg from '@/assets/game/action_imgs/gift.webp'
import faceScanImg from '@/assets/game/action_imgs/face_scan.png'
import emailImg from '@/assets/game/action_imgs/email.png'
import cookiesImg from '@/assets/game/action_imgs/cookies.png'
import threeOnlineRulesImg from '@/assets/game/action_imgs/3onlineRules.png'
import shouldYouPost1bImg from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-1b-highres.png'
import shouldYouPost1Img from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-1-highres.png'
import shouldYouPost2bImg from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-2b-highres.png'
import shouldYouPost2Img from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-2-highres.png'
import shouldYouPost3bImg from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-3b-highres.png'
import shouldYouPost3Img from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-3-highres.png'
import shouldYouPost4bImg from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-4b-highres.png'
import shouldYouPost4Img from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-4-highres.png'
import shouldYouPost5bImg from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-5b-highres.png'
import shouldYouPost5Img from '@/assets/game/action_imgs/shouldYouPost/Should-you-post-5-highres.png'
import digitalFootprintImg from '@/assets/game/action_imgs/digitalFootprint.webp'
// Central registry of all background images
export const backgroundImages = {
  // Common backgrounds
  digipalzHeadquarter,
  missionBg,
  dialogueBg,

  // Scene-specific backgrounds
  computerLab: backgroundImgCompouterLab,
  redValley: backgroundImgRedVally,
  principalOffice: backgroundImgPrincipalOffice,
  playground: backgroundImgPlayground,
  azabukiOffice: backgroundImgAzabukiOffice,
  guidanceCounselorOffice: backgroundImgAzabukiOffice,
  libraryScene: librarySceneBg,
  policeStation: policeStationBg,
  kitchen: kitchenBg,
  babyRoom: babyRoomBg,
  babyMonitor: babyMonitorBg,
  declanBedroom: declanBedroomBg,
  cabinFamilyRoom: cabinFamilyRoomBg,
  caymanAirport: caymanAirportBg,
  caymanSecurityGate: caymanSecurityGateBg,
  cabinLivingRoom: cabinLivingRoomBg,
  library: libraryBg,
  // EXACT MATCHES FOR JSON FILE BACKGROUNDS
  // This is important! The keys must match the "background" field in the JSON exactly
  'elementry_school_bg.svg': backgroundImgRedVally,
  'computerLab.jpg': backgroundImgCompouterLab,
  'principal_office.jpg': backgroundImgPrincipalOffice,
  'playground.jpg': backgroundImgPlayground,
  'guidance_counselor_office.jpg': backgroundImgAzabukiOffice,
  'mrazabuki-office.png': backgroundImgAzabukiOffice,
  'digipalz_headquarter.webp': digipalzHeadquarter,
  'mission_one_bg.webp': missionBg,
  'dialogue_bg.webp': dialogueBg,
  'librarySceneBg.png': librarySceneBg,
  'police_station.webp': policeStationBg,
  'blue_cabin.webp': blueMountainBg,
  'kitchen.webp': kitchenBg,
  'baby_room.webp': babyRoomBg,
  'baby_monitor.webp': babyMonitorBg,
  'declan_bedroom.webp': declanBedroomBg,
  'cabin_family_room.webp': cabinFamilyRoomBg,
  'cayman_airport.webp': caymanAirportBg,
  'cayman_security_gate.webp': caymanSecurityGateBg,
  'cabin_living_room.webp': cabinLivingRoomBg,
  'kitchen.jpg': kitchen2Bg,
  'library_bg.webp': libraryBg
}

// Central registry of all character images
export const characterImages = {
  // Character images mapped by their filename in the JSON
  'pasternak.png': mrPasternakImg,
  'milo.webp': miloImg,
  'luna.webp': lunaImg,
  'mr_spivak.svg': mrSpivakImg,
  'mr_spivak.webp': mrSpivakImg,
  'principal_finley.png': principalFinleyImg,
  'katie.webp': katieImg,
  'mr_azabuki.webp': mrAzabukiImg,
  'robotoro.webp': robotoroImg,
  'agent_phoebe.png': agentPhoebeImg,
  'emilio.webp': officerEmilioImg,
  'declan.webp': declanImg,
  'mrs_delavoy.png': mrsDelavoyImg,
  'astra.webp': astraImg,
  'speaker.png': speakerImg,
  'officer_ebanks.webp': officerEbanksImg,
  'robotoro.gif': roboGif,
  'ms_lopez.webp': msLopez,
  'grace.webp': graceImg,
  // Direct references by character name
  milo: miloImg,
  luna: lunaImg,
  mrPasternak: mrPasternakImg,
  mrSpivak: mrSpivakImg,
  robotoro: robotoroImg,
  robotoroDialoguebox: robotoroDialogueboxImg,
  katie: katieImg,
  mrAzabuki: mrAzabukiImg,
  principalFinley: principalFinleyImg,
  agentPhoebe: agentPhoebeImg,
  officerEmilio: officerEmilioImg,
  declan: declanImg,
  mrsDelavoy: mrsDelavoyImg,
  astra: astraImg,
  speaker: speakerImg,
  officerEbanks: officerEbanksImg,
  robotoroGif: roboGif,
  msLopez: msLopez,
  grace: graceImg
}

// Central registry of all article images
export const articleImages = {
  // Article icons
  newsIcon: newsIconImg,

  // Article profile images mapped by their filename
  'autom_img.png': automImg,
  'police_badge.png': policeBadgeImg,
  'baby_article.webp': babyImg,
  'mission4.webp': mission4ArticleImg,
  // Direct references
  autumn: automImg,
  policeBadge: policeBadgeImg,
  baby: babyImg,
  mission4: mission4ArticleImg
}

// Central registry of all action images
export const actionImages = {
  // Action images mapped by their filename in the JSON
  'school.png': schoolImg,
  'pap2.png': pap2Img,
  'pap3.png': pap3Img,
  'page9.png': page9Img,
  'pap1.png': pap1Img,
  'page8.png': page8Img,
  'page7.png': page7Img,
  'page6.png': page6Img,
  'page5.png': page5Img,
  'page4.png': page4Img,
  'page3.png': page3Img,
  'page2.png': page2Img,
  'page10.png': page10Img,
  'page1.webp': page1Img,
  'glass_house.webp': glassHouseImg,
  'f1.png': f1Img,
  'fullName.png': fullNameImg,
  'declan_letter_open.png': declanLetterOpenImg,
  'declan_letter_close.webp': declanLetterCloseImg,

  'digitalFootprint.webp': digitalFootprintImg,
  'astra-bag.png': astraBagImg,
  'astra-bag-item3.png': astraBagItem3Img,
  'astra-bag-item2.png': astraBagItem2Img,
  'address.png': addressImg,
  'astra-bag-item1.png': astraBagItem1Img,
  'thumb_scan.png': thumbScanImg,
  'sock.webp': sockImg,
  'red_flag3.png': redFlag3Img,
  'red_flag2.png': redFlag2Img,
  'red_flag1.png': redFlag1Img,
  'portal.webp': portalImg,
  'password_rule4.png': passwordRule4Img,
  'password_rule2.png': passwordRule2Img,
  'password_rule3.png': passwordRule3Img,
  'password_rule1.png': passwordRule1Img,
  'gift.webp': giftImg,
  'face_scan.png': faceScanImg,
  'email.png': emailImg,
  'cookies.png': cookiesImg,
  '3onlineRules.png': threeOnlineRulesImg,
  'Should-you-post-1b-highres.png': shouldYouPost1bImg,
  'Should-you-post-1-highres.png': shouldYouPost1Img,
  'Should-you-post-2b-highres.png': shouldYouPost2bImg,
  'Should-you-post-2-highres.png': shouldYouPost2Img,
  'Should-you-post-3b-highres.png': shouldYouPost3bImg,
  'Should-you-post-3-highres.png': shouldYouPost3Img,
  'Should-you-post-4b-highres.png': shouldYouPost4bImg,
  'Should-you-post-4-highres.png': shouldYouPost4Img,
  'Should-you-post-5b-highres.png': shouldYouPost5bImg,
  'Should-you-post-5-highres.png': shouldYouPost5Img,

  // Direct references for common action images
  school: schoolImg,
  cookies: cookiesImg,
  email: emailImg,
  sock: sockImg,
  portal: portalImg,
  gift: giftImg,
  thumbScan: thumbScanImg,
  faceScan: faceScanImg,
  address: addressImg,
  astraBag: astraBagImg,
  declanLetterOpen: declanLetterOpenImg,
  declanLetterClose: declanLetterCloseImg,
  passwordRule1: passwordRule1Img,
  passwordRule2: passwordRule2Img,
  passwordRule3: passwordRule3Img,
  passwordRule4: passwordRule4Img,
  redFlag1: redFlag1Img,
  redFlag2: redFlag2Img,
  redFlag3: redFlag3Img,
  threeOnlineRules: threeOnlineRulesImg,
  glassHouse: glassHouseImg,
  fullName: fullNameImg,
  f1: f1Img,
  astraBagItem1: astraBagItem1Img,
  astraBagItem2: astraBagItem2Img,
  astraBagItem3: astraBagItem3Img,
  shouldYouPost1: shouldYouPost1Img,
  shouldYouPost1b: shouldYouPost1bImg,
  shouldYouPost2: shouldYouPost2Img,
  shouldYouPost2b: shouldYouPost2bImg,
  shouldYouPost3: shouldYouPost3Img,
  shouldYouPost3b: shouldYouPost3bImg,
  shouldYouPost4: shouldYouPost4Img,
  shouldYouPost4b: shouldYouPost4bImg,
  shouldYouPost5: shouldYouPost5Img,
  shouldYouPost5b: shouldYouPost5bImg
}

// Scene backgrounds by ID for backward compatibility - but we'll prefer using background name directly
export const backgroundImagesById = {
  1: backgroundImgRedVally, // Red Valley Elementary
  2: backgroundImgCompouterLab, // Computer Lab
  3: backgroundImgPrincipalOffice, // Principal's Office
  4: backgroundImgPlayground, // Playground
  5: backgroundImgAzabukiOffice // Mr. Azabuki's Office
}

// Helper function to get a character image by name or filename
export const getCharacterImage = (identifier) => {
  return characterImages[identifier] || null
}

// Helper function to get a background image by name or ID
export const getBackgroundImage = (identifier) => {
  // First try to get by direct name
  if (backgroundImages[identifier]) {
    return backgroundImages[identifier]
  }

  // For backward compatibility, check if it's a numeric ID
  if (typeof identifier === 'number' || !isNaN(parseInt(identifier))) {
    return backgroundImagesById[parseInt(identifier)] || null
  }

  return null
}

// Helper function to get an article image by name or filename
export const getArticleImage = (identifier) => {
  return articleImages[identifier] || null
}

// Helper function to get an action image by name or filename
export const getActionImage = (identifier) => {
  return actionImages[identifier] || null
}
